import { ChainId } from "../enums";
import { RawApplication } from "./application";
import { Currency } from "./currency";
import { MarketingActivity } from "./marketing-activity";
import { ModalField } from "./modal-field";
import { ProjectLink } from "./project-link";
import { ProjectPayment } from "./project-payment";
import { Translation } from "./translation";

export enum ProjectStatus {
  NOT_DEPLOYED = "not deployed",
  UPCOMING = "upcoming",
  REDEEM = "redeem",
  FCFS = "fcfs",
  CLAIM = "claim",
  DISTRIBUTED = "distributed",
}

export enum RefundType {
  NO_REFUND = "noRefund",
  WITH_PROJECT_TOKENS = "withProjectTokens",
  WITHOUT_PROJECT_TOKENS = "withoutProjectTokens",
  REFUND_POLICY_WITH_CLAIM = "refundPolicyWithClaim",
  REFUND_POLICY_WITHOUT_CLAIM = "refundPolicyWithoutClaim",
  REFUNDED = "refunded",
}

export type RawProject = {
  id: string;
  weight?: number; // вес для сортировки
  createdAt: number; // Date.now()
  updatedAt: number; // Date.now()
  title: string;
  description: string;
  exchangeRate: string | ""; // BigNumber.toString()
  whitelistStartDate: number; // Date.now()
  whitelistEndDate: number; // Date.now()
  swapStartDate: number; // Date.now()
  swapEndDate: number; // Date.now()
  fcfsEndDate: number; // Date.now()
  fcfsMaxCount: string; // BigNumber.toString()
  totalRaise: string | ""; // BigNumber.toString()
  idoBannerUrl?: string;
  idoLogoUrl?: string;
  tokenLogoUrl?: string;
  network: ChainId;
  claimType: string;
  vestingSchendule: string;
  status: ProjectStatus;
  invested: string | ""; // BigNumber.toString()
  visibility: boolean;
  fcfsFree?: boolean;
  minPercent: string; // 0-100
  minAmount: string; // BigNumber.toString()
  refundType: RefundType;
  refundPolicyTime: number;
  refundTxHash?: string;

  /* relations */
  modalFields?: ModalField[];
  activities?: MarketingActivity[];
  translations?: Translation[];
  links?: ProjectLink[];
  applications?: RawApplication[];
  exchangeCurrency?: Currency[];
  claimCurrency?: Currency[];
  payments: ProjectPayment[];
};
